<template>
  <div>
    <v-btn text @click="$emit('go-to-results')" class="mb-6 ml-n12" small
      ><v-icon class="mr-2" small>mdi-arrow-left-circle</v-icon> <ressource code="retour-aux-resultats"></ressource
    ></v-btn>
    <template v-if="loading">
      <opq-loading size="200"></opq-loading>
    </template>
    <template v-else>
      <template v-show="contact">
        <ContactDetaille :contact="contact"></ContactDetaille>
      </template>
    </template>
  </div>
</template>

<script>
import ContactDetaille from "./ContactDetaille.vue"
export default {
  components: { ContactDetaille },
  props: {
    detailsConnus: {
      type: Array,
      default() {
        return []
      }
    },
    cartesAffairesAbregees: {
      type: Array
    },
    id: { type: String, required: true },
    loading: { type: Boolean }
  },
  mounted() {
    if (!this.contactDetaille) {
      this.$emit("carte-affaire-selected", this.id)
    }
  },
  computed: {
    contact() {
      return this.detailsConnus.find((d) => d.id == this.id)
    }
  }
}
</script>

<style>
</style>